export const PRODUCT_LIST_FILTER_CODE_OBJ = {
    /** 전체 제품 */
    all_product: "0",
    /** 사진 선택 요청 */
    need_to_request: "1",
    /** 사진 편집 중 */
    editing: "2",
    /** 편집 사진 승인 요청 */
    need_to_confirm: "3",
    /** 편집완료(상품제작) */
    complete: "4",
    /** 출고 완료 */
    shipping_complete: "5",
} as const;

export const PRODUCT_LIST_FILTER_TEXT_OBJ = {
    "0": "전체 제품",
    "1": "사진 선택 요청",
    "2": "사진 편집 중",
    "3": "편집 사진 승인 요청",
    "4": "편집완료(상품제작)",
    "5": "출고 완료",
} as const;

// 제품 타입
export const PRODUCT_TYPE_CODE_OBJ = {
    /** 촬영 */
    shoot: "1",
    /** 앨범 */
    album: "2",
    /** 액자 */
    frame: "3",
    /** 기타상품 */
    other: "4",
    /** 파일 */
    file: "5",
    /** 메이크업 */
    makeup: "6",
    /** 의상대여 */
    costume_rental: "7"
} as const;

export const PRODUCT_TYPE_TEXT_OBJ = {
    "1": "촬영",
    "2": "앨범",
    "3": "액자",
    "4": "기타상품",
    "5": "파일",
    "6": "메이크업",
    "7": "의상대여",
} as const;

// 제품 상태
export const PRODUCT_STATE_CODE_OBJ = {
    /** 신청불가 */
    application_not_possible: "1",
    /** 신청가능 */
    application_possible: "2",
    /** 신청중 */
    application_in_progress: "3",
    /** 편집중 */
    editing: "4",
    /** 승인요청 */
    confirm_request: "5",
    /** 편집완료(상품제작) */
    edit_end: "6",
    /** 승인거절 */
    confirm_rejected: "7",
} as const;

// 실제 서버에서 응답으로 오는 문구
export const PRODUCT_STATE_TEXT_OBJ = {
    /** 신청불가 */
    "1": "모든 촬영 완료 후 진행",
    /** 신청가능 */
    "2": "사진 선택하기",
    /** 신청중 */
    "3": "신청완료 (편집 진행 전)",
    /** 편집중 */
    "4": "사진 편집중",
    /** 승인요청 */
    "5": "편집 사진 승인하기",
    /** 편집완료(상품제작) */
    "6": "편집완료(상품제작)",
    /** 승인거절 */
    "7": "승인거절",
} as const;